import React, { useRef } from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
type Props = {
  defaultValue: string[]
  onChange(values: string[]): void
  options: string[]
  style?: { [key: string]: string | number }
}

const defaultStyle = { margin: 16, minWidth: 200 }

export default function StatusFilter({
  defaultValue,
  onChange,
  options,
  style = defaultStyle
}: Props) {
  const refTimeout = useRef<NodeJS.Timeout>(null)
  const { t } = useTranslation()

  return (
    <Select
      data-test-id="request-filter-list"
      defaultValue={defaultValue}
      mode="multiple"
      onChange={(values: string[]) => {
        clearTimeout(refTimeout.current)
        refTimeout.current = setTimeout(() => {
          onChange(values)
        }, 1000)
      }}
      placeholder={t('common.status-filter')}
      style={style}
    >
      {options.map(filter => (
        <Select.Option
          data-test-id={`request-filter-item-${filter}`}
          key={filter}
        >
          {t(`common.status.unified.${filter}`)}
        </Select.Option>
      ))}
    </Select>
  )
}
